import { render } from "./PersonalfunktionElementInListe.pug?vue&type=template&id=bc1a1382&lang=pug"
import script from "./PersonalfunktionElementInListe.js?vue&type=script&lang=js"
export * from "./PersonalfunktionElementInListe.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__